import { set } from 'lodash/fp';

const checkTotal = (field, total, value, errorString) => (errors) => (
    value !== total
        ? set(field, errorString, errors)
        : errors
);

export default checkTotal;
